import React from 'react';
import { Handle, Position } from 'reactflow';
import type { NodeProps } from 'reactflow';
import { NODE_PALETTE } from './types';
import type { FlowNodeData } from './types';

export const CustomNode: React.FC<NodeProps<FlowNodeData>> = ({ data, selected }) => {
  const nodeInfo = NODE_PALETTE.find(n => n.type === data.nodeType);

  if (!nodeInfo) {
    return null;
  }

  const showTopHandle = data.nodeType !== 'START';
  const showBottomHandle = data.nodeType !== 'END' && data.nodeType !== 'CLOSE_CONVERSATION';

  return (
    <div className={`
      relative px-4 py-3 rounded-lg shadow-lg min-w-[180px]
      ${nodeInfo.color} text-white
      ${selected ? 'ring-4 ring-blue-400 ring-opacity-50' : ''}
      transition-all duration-200
    `}>
      {showTopHandle && (
        <Handle
          type="target"
          position={Position.Top}
          className="w-3 h-3 bg-white border-2 border-gray-400"
        />
      )}

      <div className="flex items-center gap-2">
        <span className="text-2xl">{nodeInfo.icon}</span>
        <div className="flex-1">
          <div className="font-semibold text-sm">{data.label || nodeInfo.label}</div>
          {data.config && Object.keys(data.config).length > 0 && (
            <div className="text-xs opacity-75 mt-1">
              {data.nodeType === 'SEND_MESSAGE' && data.config.message && (
                <div className="truncate max-w-[140px]">
                  {data.config.message.substring(0, 30)}...
                </div>
              )}
              {data.nodeType === 'SEND_TEMPLATE' && data.config.templateName && (
                <div className="truncate max-w-[140px]">
                  {data.config.templateName}
                </div>
              )}
              {data.nodeType === 'CONDITION' && (
                <div className="text-xs">
                  {data.config.field ? `${data.config.field} ${data.config.operator} ${data.config.value}` : 'Não configurado'}
                </div>
              )}
              {data.nodeType === 'UPDATE_STATUS' && data.config.status && (
                <div>{data.config.status}</div>
              )}
              {data.nodeType === 'TRANSFER_DEPARTMENT' && data.config.departmentId && (
                <div>Dept: {data.config.departmentName || data.config.departmentId.substring(0, 8)}</div>
              )}
              {data.nodeType === 'SET_VARIABLE' && data.config.variableName && (
                <div>{data.config.variableName}</div>
              )}
            </div>
          )}
        </div>
      </div>

      {showBottomHandle && (
        <Handle
          type="source"
          position={Position.Bottom}
          className="w-3 h-3 bg-white border-2 border-gray-400"
        />
      )}
    </div>
  );
};
